import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Toaster } from 'react-hot-toast';

import store, { persistor } from './store/configureStore';
import { createTheme } from 'src/theme';
import Routes from './Routes';

// Disable automatic scroll restoration to allow manual control
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes />
            <Toaster position="bottom-center" reverseOrder={false} />
          </ThemeProvider>
        </React.StrictMode>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);
